module.exports = __webpack_public_path__ + "img/hr-level2addon_mining_tool.b6b0d874.png";